export default [
    {
		path: '/shop',
		name: 'shop',
		component: () => import('@/views/shop/index'),
		meta: {
			metaInfo: {
			  title: "儿童绘本 | 儿童绘本读物 | 儿童教育绘本 | 儿童绘本推荐 | 儿童双语绘本",
			  keywords: "儿童绘本，儿童绘本读物，儿童教育绘本，儿童绘本推荐，儿童双语绘本，儿童绘本故事，幼儿绘本，儿童绘本阅读，儿童早教书本，儿童有声绘本，启蒙早教绘本",
			  description: "新语境绘本是中国管理科学研究院学术委员会“十三五”规划课题，绘本分为幼儿启蒙多语故事绘本和幼儿启蒙多语生活绘本，共31册。经中国管理科学研究院学术委员会儿童多语教育研究中心出品",
			},
		}
	},
    {
		path: '/goods-detail',
		name: 'goods-detail',
		component: () => import('@/views/shop/goods-detail')
	},
]


// WEBPACK FOOTER //
// ./src/router/modules/shop.js